import { FC } from "react";
import styles from "./Chat.module.scss";
import checkDouble from "../../images/icons/check-double.svg";
import checkSingle from "../../images/icons/check.svg";

interface MessageProps {
  message: string;
  time: string;
  isRead?: boolean;
  avatar?: string;
  userName?: string;
  attachmentUrl?: string | null;
}

// Component for incoming messages
export const Message: FC<MessageProps> = ({
  message,
  time,
  avatar,
  userName,
}) => {
  return (
    <div className={styles.messageContainer}>
      <div className={styles.messageContentWrapper}>
        {userName && <div className={styles.messageUserName}>{userName}</div>}
        <div className={styles.blockMessage}>
          <div className={styles.messageText}>{message}</div>
          <div className={styles.messageTimeWrapper}>
            <span className={styles.messageTime}>{time}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

// Component for outgoing messages
export const MessageTwo: FC<MessageProps> = ({
  message,
  time,
  isRead = false,
  attachmentUrl,
}) => {
  return (
    <div className={styles.myMessageContainer}>
      <div className={styles.blockMessageTwo}>
        <div className={styles.messageText}>
          {attachmentUrl ? (
            <img
              src={attachmentUrl}
              className={styles.imgMessage}
              alt="Image"
            ></img>
          ) : (
            message
          )}
        </div>
        <div className={styles.messageFooter}>
          <span className={styles.messageTime}>{time}</span>
          <img
            src={isRead ? checkDouble : checkSingle}
            alt={isRead ? "Read" : "Delivered"}
            className={`${styles.messageStatus} ${isRead ? styles.statusRead : ""}`}
            title={isRead ? "Read" : "Delivered"}
          />
        </div>
      </div>
    </div>
  );
};
